// NOTE: Please update the README.md in shared/questionnaire-engine if this is modified.
export var FieldTypes;
(function (FieldTypes) {
    FieldTypes["input"] = "input";
    FieldTypes["textarea"] = "textarea";
    FieldTypes["radio"] = "radio";
    FieldTypes["dropdown"] = "dropdown";
    FieldTypes["checkbox"] = "checkbox";
    FieldTypes["date"] = "date";
    FieldTypes["yearMonth"] = "yearMonth";
    FieldTypes["number"] = "number";
    FieldTypes["money"] = "money";
    FieldTypes["agree"] = "agree";
    FieldTypes["checkboxGroup"] = "checkboxGroup";
    FieldTypes["phone"] = "phone";
    FieldTypes["currencyCard"] = "currencyCard";
    FieldTypes["button"] = "button";
    FieldTypes["autocomplete"] = "autocomplete";
    FieldTypes["information"] = "information";
    FieldTypes["signature"] = "signature";
})(FieldTypes || (FieldTypes = {}));
